<template>
  <!--eslint-disable-->
  <v-container class="pa-0">
    <v-card flat class="pa-0">
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="settingsFormData.minor_settings.dashboard_links"
          dense
          item-key="link"
        >
          <template v-slot:top>
            <div class="d-flex">
              <v-spacer />
              <v-btn color="primary" small @click="addNewLine">
                <v-icon class="mr-1" size="12">mdi-plus</v-icon>
                new link
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.name`]="{ item, index }">
            <v-text-field v-model="item.name" v-if="editingIndex === index">
            </v-text-field>
            <span v-else>{{ item.name }}</span>
          </template>
          <template v-slot:[`item.link`]="{ item, index }">
            <v-text-field
              v-model="item.link"
              v-if="editingIndex === index"
            ></v-text-field>
            <a v-else :href="item.link" target="_blank">{{ item.link }}</a>
          </template>
          <template v-slot:[`item.actions`]="{ item, index }">
            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-on="on"
                    v-bind="attrs"
                    @click="editingIndex === index ? save() : editItem(index)"
                    class="mr-2"
                    :color="editingIndex === index ? 'primary' : 'info'"
                  >
                    {{ `${editingIndex === index ? "done" : "edit"}` }}
                  </v-icon>
                </template>
                <span>{{ `${editingIndex === index ? "done" : "edit"}` }}</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
/*  eslint-disable */
// import { helper } from "@/packages/dashboard/utils";
export default {
  name: "DashboardLinks",
  props: {
    settingsFormData: Object,
    saveSettings: Function,
  },
  data() {
    return {
      editingIndex: -1,
      singleSelect: false,
      defaultLineItem: {
        link: "",
        name: "",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Administrator/getSettings");
    });
  },
  computed: {
    settings() {
      return this.$store.getters["Administrator/administratorGetters"](
        "settings",
      );
    },
    headers() {
      return [
        { text: "Name", value: "name", align: "start" },
        { text: "Links", value: "link", align: "start" },
        { text: "", value: "actions", align: "start" },
      ];
    },
  },
  methods: {
    addNewLine() {
      this.settingsFormData.minor_settings.dashboard_links.unshift({
        ...this.defaultLineItem,
      });
      this.settingsFormData.minor_settings.dashboard_links.forEach(
        function (item, index) {
          item.id = index;
        },
      );
      this.editItem(0);
    },
    editItem(i) {
      console.log(this.editingIndex === i);
      this.editingIndex === i
        ? (this.editingIndex = -1)
        : (this.editingIndex = i);
      console.log(this.editingIndex, i);
    },
    save() {
      this.editingIndex = -1;
      this.saveSettings();
    },
  },
  watch: {
    settings: {
      handler: async function (val) {
        if (val) {
          this.settingsFormData.minor_settings =
            val && val.minor_settings
              ? JSON.parse(val.minor_settings)
              : this.settingsFormData.minor_settings;
          this.settingsFormData.site_colors =
            val && val.site_colors
              ? JSON.parse(val.site_colors)
              : this.objectToArray(this.$vuetify.theme.themes.light);
          this.settingsFormData.site_installed_packages =
            val && val.site_installed_packages
              ? JSON.parse(val.site_installed_packages)
              : [];
        }
      },
      deep: true,
    },
  },
};
</script>
